module.exports = __webpack_public_path__ + "img/logo-rbl.dde0bf08.jpg";